/// <reference types="@angular/localize" />
import * as Sentry from '@sentry/angular';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { polyfill } from 'mobile-drag-drop';
import { scrollBehaviourDragImageTranslateOverride } from 'mobile-drag-drop/scroll-behaviour';

Sentry.init({
    dsn: 'https://93db3beb573ac3a2a64ed4b99a217bbf@o4508949776367616.ingest.de.sentry.io/4508981759246416',
});

bootstrapApplication(AppComponent, appConfig).catch((err) =>
    console.error(err)
);

polyfill({
    // use this to make use of the scroll behaviour
    dragImageTranslateOverride: scrollBehaviourDragImageTranslateOverride,
    forceApply: true,
});

// workaround to make scroll prevent work in iOS Safari > 10
try {
    window.addEventListener('touchmove', function () {}, { passive: false });
} catch (e) {}
